import CKDisplay from "@/components/ckeditor/CKDisplay"
import type { NoteEntry } from "@/models"
import { useUser } from "@/stores/coreDataStore"
import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"

interface Props {
	note: NoteEntry
}

const byStyles = css`
	font-size: 0.92em;
	strong {
		font-weight: 600;
	}
	margin-bottom: 0.25em;
`

const NarrativeDisplay: ReactiveComponent<Props> = (props) => {
	const handler = useIncidentHandler()
	const createdBy = useUser(() => props.note.creationMetadata.userId)

	return () => (
		<div style={{ breakInside: "avoid" }}>
			<div class={byStyles}>
				<strong title={createdBy.value?.emailAddress}>{createdBy.value?.fullName ?? "Unknown"}</strong> at{" "}
				{handler.formatTime(props.note.creationMetadata.timeStamp)} (UTC)
			</div>
			<CKDisplay htmlContent={props.note.text} />
		</div>
	)
}

export default defineComponent(NarrativeDisplay, inferProps<Props>())
